export function singaporeYmd(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Singapore",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const get = (type) => Number(parts.find((part) => part.type === type)?.value || 0);
  return { year: get("year"), month: get("month"), day: get("day") };
}

export function toDayLabel({ year, month, day }) {
  const yy = String(year).slice(-2).padStart(2, "0");
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  return `${dd}/${mm}/${yy}`;
}

export function addCivilDays({ year, month, day }, delta) {
  const next = new Date(Date.UTC(year, month - 1, day + Number(delta || 0)));
  return {
    year: next.getUTCFullYear(),
    month: next.getUTCMonth() + 1,
    day: next.getUTCDate(),
  };
}

export function last30DayLabels(now = new Date()) {
  const today = singaporeYmd(now);
  const labels = new Set();
  for (let i = 0; i < 30; i += 1) {
    labels.add(toDayLabel(addCivilDays(today, -i)));
  }
  return labels;
}

export function sumDayCounts(rows, allowedLabels) {
  const allowed = allowedLabels instanceof Set ? allowedLabels : new Set(allowedLabels || []);
  return (Array.isArray(rows) ? rows : []).reduce((total, row) => {
    const date = String(row?.date || "").trim();
    if (!allowed.has(date)) return total;
    const n = Number(row?.count);
    return total + (Number.isFinite(n) ? n : 0);
  }, 0);
}

export function countByDate(rows) {
  const map = {};
  (Array.isArray(rows) ? rows : []).forEach((row) => {
    const date = String(row?.date || "").trim();
    if (!date) return;
    const n = Number(row?.count);
    map[date] = Number.isFinite(n) ? n : 0;
  });
  return map;
}

export function daysInMonth(year, month) {
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

export function monthDayLabels(year, month) {
  const labels = new Set();
  const total = daysInMonth(year, month);
  for (let day = 1; day <= total; day += 1) {
    labels.add(toDayLabel({ year, month, day }));
  }
  return labels;
}

export function mondayFirstMonthCells(year, month) {
  const weekday = new Date(Date.UTC(year, month - 1, 1)).getUTCDay();
  const leading = (weekday + 6) % 7;
  const total = daysInMonth(year, month);
  const cells = [];
  for (let i = 0; i < leading; i += 1) cells.push(null);
  for (let day = 1; day <= total; day += 1) cells.push(day);
  while (cells.length % 7 !== 0) cells.push(null);
  return cells;
}
